export { default as ServiceAreasStorySection } from './story-section';
